import type { AccentTone } from '@/app/dashboard/navigation';

/**
 * Maps an AccentTone to the Tailwind classes for an active nav item's
 * left accent bar + icon/text color. docs/DESIGN_SYSTEM.md §4.11 — "active
 * item gets a left 2px accent bar (domain-colored)". Batch 5: 12-domain
 * system, see app/dashboard/navigation.ts for the rationale.
 */
export const accentBarClass: Record<AccentTone, string> = {
  neutral: 'border-text-secondary',
  security: 'border-accent-security-500',
  automod: 'border-accent-automod-500',
  moderation: 'border-accent-moderation-500',
  management: 'border-accent-management-500',
  community: 'border-accent-community-500',
  automation: 'border-accent-automation-500',
  ai: 'border-accent-ai-500',
  tickets: 'border-accent-tickets-500',
  analytics: 'border-accent-analytics-500',
  settings: 'border-accent-settings-500',
  logs: 'border-accent-logs-500',
  backups: 'border-accent-backups-500',
  help: 'border-accent-help-500',
};

export const accentTextClass: Record<AccentTone, string> = {
  neutral: 'text-text-primary',
  security: 'text-accent-security-400',
  automod: 'text-accent-automod-400',
  moderation: 'text-accent-moderation-400',
  management: 'text-accent-management-400',
  community: 'text-accent-community-400',
  automation: 'text-accent-automation-400',
  ai: 'text-accent-ai-400',
  tickets: 'text-accent-tickets-400',
  analytics: 'text-accent-analytics-400',
  settings: 'text-accent-settings-400',
  logs: 'text-accent-logs-400',
  backups: 'text-accent-backups-400',
  help: 'text-accent-help-400',
};
